<template lang="pug">
p {{ value }}
</template>

<script>
export default {
	name: "IntegerValue",
	props: {
		value: {
			type: Number,
			required: false,
			default: null
		}
	}
};
</script>
